<template>
  <div class="fixed-btn">
    <!-- 悬浮按钮 拨打电话 -->
    <img
      src="@/assets/img/orderGeneral/order_concat_servicer@2x.png"
      @click="clickPhone"
    >
    <a
      :href="`tel:${phone}`"
      ref="telPhone2"
      style="display:none;"
    />
  </div>
</template>

<script>
export default {
  name: 'PhoneCall',
  props: {
    phone: {
      type: String,
      default: '4000026862'
    }
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    clickPhone() {
      this.$dialog.confirm({
        title: '提示',
        message:
          `确定拨打电话:${this.phone}`
      })
        .then(() => {
          // on confirm
          this.$refs.telPhone2.click();
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-btn{
  position: fixed;
  right: 10px;
  bottom: 188px;

  width: 60px;
  height: 60px;

  img{
    width: 100%;
    height: 100%;
  }
}
</style>
